import { Component, input, model, OnInit, signal } from '@angular/core';
import { CardComponent } from '../../../../../shared/components/card/card.component';
import { NgClass } from '@angular/common';
import { PetFormComponent } from '../../../../../components/forms/pet-form/pet-form.component';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { PetService } from '../../../../../services/pet/pet.service';
import { MessageService } from 'primeng/api';
import { Pet } from '../../../../../shared/models/pet.model';
import { FormsModule } from '@angular/forms';
import { finalize } from 'rxjs';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faShieldDog, faTrashCan, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { PetModalComponent } from '../../../../../components/modals/pet-modal/pet-modal.component';
import { Router } from '@angular/router';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-pet-section',
  imports: [
    PetModalComponent,
    CardComponent,
    PetFormComponent,
    ToggleSwitchModule,
    FaIconComponent,
    FormsModule,
    TooltipModule,
    NgClass
  ],
  templateUrl: './pet-section.component.html',
  styleUrl: './pet-section.component.scss'
})
export class PetSectionComponent {
  readonly trashIcon: IconDefinition = faTrashCan;
  readonly shieldIcon: IconDefinition = faShieldDog;

  readonly pet = model.required<Pet | null>();

  readonly isModalOpen = signal<boolean>(false);

  readonly isLoading = signal<boolean>(false);
  readonly isEditable = signal<boolean>(false);

  constructor(private readonly petService: PetService,
    private readonly route: Router,
    private readonly messageService: MessageService
  ) {}

  onOpenModal(): void {
    this.isModalOpen.set(true);
  }

  redirectRoute(): void {
    this.route.navigate(['/']);
  }

  updatePet(fields: any): void {
    const { name, birthdate, gender, specie, breed, temperament, foodType, files } = fields;
    const newPet: Pet = { name, birthdate, gender, specie, breed, temperament, foodType, files };

    newPet.id = this.pet()!.id!;

    const formData = new FormData();

    formData.append('name', newPet.name);
    formData.append('birthdate', newPet.birthdate.toISOString());
    formData.append('gender', newPet.gender);
    formData.append('specie', newPet.specie);
    formData.append('breed', newPet.breed ?? '');
    formData.append('foodType', newPet.foodType ?? '');
    formData.append('id', newPet.id);
    temperament.forEach((temp: string) => {
      formData.append('temperament', temp);
    });

    files.forEach((file: File) => {
      formData.append('files', file, file.name);
    });

    this.petService.updatePet(formData)
      .pipe(finalize(() => this.isLoading.set(false)))
      .subscribe({
        next: (pet: Pet) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'As informações foram atualizadas!',
            life: 4000
          });

          this.pet.set(pet);
        }, error: () => {
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail: 'Falha ao atualizar o pet!',
            life: 4000
          });
        }
      });
  }
}
